const AboutContent = () => {
  return (
    <div id="about" className="block spacer">
      <div className="row gutter-width-md with-pb-md">
        <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
          <div className="photographers-grid">
            <div className="photographer-image">
              <img src="/assets/img/bg/nonah.jpg" alt="Photographer Nonah" />
            </div>
          </div>
        </div>

        <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8">
          <h5>Nonah Chhantyal</h5>
          <p>
            A photographer with a soft and kind heart, an easy-going soul, and a
            deep love for capturing life’s most beautiful milestones. I believe
            luxury isn’t just about aesthetics; it’s about emotion, intention,
            and how genuinely you’re cared for throughout your experience.
          </p>
          <p>
            With a refined yet approachable style, I specialise in weddings,
            elegant maternity portraits, and life events that deserve to be
            remembered with grace and artistry. My clients come to me for images
            that feel warm, timeless, and deeply emotional — captured in a way
            that feels effortless and natural.
          </p>
          <p>
            I bring a bubbly, calming presence to every session, ensuring you
            feel comfortable, celebrated, and seen. Whether it’s guiding a bride
            through the whirlwind of her wedding day or gently documenting the
            glow of motherhood, I create a space where your true emotions can
            unfold beautifully.
          </p>
          <p>
            My photography blends tenderness with sophistication soft tones,
            natural light, and honest connection resulting in imagery that feels
            both high-end and heart-led.
          </p>
          <p>
            If you’re dreaming of elegant, emotional and artfully captured
            moments, I would be honoured to tell your story.
          </p>
        </div>
      </div>
      <div className="row gutter-width-md with-pb-md mt-5">
        <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
          <div className="photographers-grid">
            <div className="photographer-image">
              <img src="/assets/img/bg/aadil.jpg" alt="Photographer Aadil" />
            </div>
          </div>
        </div>

        <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8">
          <h5>Aadil Shrestha</h5>
          <p>
            A passionate wedding and lifestyle photographer/videographer based
            in Australia. I’m the heart behind the lens, capturing stories that
            feel real, emotional, and timeless.
          </p>
          <p>
            Photography for me is more than just taking pictures; it’s about
            preserving moments you’ll want to relive for a lifetime. Whether
            it’s the quiet glance between two people in love, the proud smile of
            a new parent, or the joyful chaos of a celebration, I aim to
            document your story in the most authentic way.
          </p>
          <p>
            With years of experience shooting weddings, maternity sessions,
            engagements, family portraits, sports, nightclubs, pubs and special
            cultural moments, my style blends natural storytelling with creative
            direction. I want you to feel comfortable, confident, and truly
            yourself in front of the camera.
          </p>
          <p>
            Every project I take on is personal. I care about the people I work
            with, the moments they trust me to capture, and the memories we
            create together.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutContent;
